import { ReactTag } from '@headlessui/react/dist/types'
import { PropsWithChildren } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import type { Arguments as UseSortableArguments } from '@dnd-kit/sortable/dist/hooks/useSortable'
import { CSS } from '@dnd-kit/utilities'
import { twMerge } from 'tailwind-merge'
import { DragIcon } from 'shared/icons/drag-icon'

interface SortableWrapperProps extends PropsWithChildren, UseSortableArguments {
  as?: ReactTag
  className?: string
}

export const TopicSortableWrapper = ({
  children,
  as = 'li',
  className,
  id,
  animateLayoutChanges,
  attributes: userDefinedAttributes,
  disabled,
  data,
  getNewIndex,
  strategy,
  resizeObserverConfig,
  transition,
}: SortableWrapperProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition: sortableTransition,
  } = useSortable({
    id,
    animateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled,
    data,
    getNewIndex,
    strategy,
    resizeObserverConfig,
    transition,
  })
  const Component = as

  const style = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition: sortableTransition,
  }

  return (
    <Component
      style={style}
      ref={setNodeRef}
      {...attributes}
      className={twMerge(
        'flex items-center gap-1 lg:text-text-primary lg:hover:text-text-primary/70',
        className,
      )}
    >
      <span className="flex shrink-0 touch-none items-center justify-center rounded-md hover:bg-black/5 lg:px-1 lg:py-1.5">
        <DragIcon className="size-5" {...listeners} />
      </span>
      {children}
    </Component>
  )
}
